import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../services/authContext';
import { Button } from '../../components/common/Button';
import { fetchAuthConfig, DEFAULT_AUTH_CONFIG, type AuthConfig } from '../../services/api/authConfig';

export function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const navigate = useNavigate();
  const [authConfig, setAuthConfig] = useState<AuthConfig>(DEFAULT_AUTH_CONFIG);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    // fetchAuthConfig() never rejects, so no error state is required here.
    // The button is immediately clickable with DEFAULT_AUTH_CONFIG before
    // this resolves — deploy skew / backend unavailability is a non-event.
    fetchAuthConfig().then(setAuthConfig);
  }, []);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent mx-auto" />
          <p className="mt-4 text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm">
        <div className="rounded-lg bg-white p-8 shadow-lg">
          {/* Logo / Title */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-primary-600">Monksheets</h1>
            <p className="mt-2 text-gray-500">Timesheet Management</p>
          </div>

          {/* Login Button */}
          <Button
            onClick={() => login(authConfig.loginPath)}
            className="w-full flex items-center justify-center gap-3"
            size="lg"
          >
            Sign in
          </Button>

          {/* Info */}
          <p className="mt-6 text-center text-sm text-gray-500">
            Use your work account to sign in
          </p>
        </div>

        {/* Footer */}
        <p className="mt-8 text-center text-xs text-gray-400">
          Monksheets
        </p>
      </div>
    </div>
  );
}
